import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer"; // Import Intersection Observer
import { ReactTyped } from "react-typed";
import "./ProductsHero.css";
import ImgDecoration from "../images/souvenir/manteles.png";
import ImgNoteook from "../images/souvenir/libreta-enano.png";
import ImgEstuche from "../images/souvenir/estuche.png";
import ImgMug from "../images/souvenir/taza-lagarto.png";
import ImgMojo from "../images/food/mojo.png";
import ImgOlive from "../images/food/oliveoil.png";
import ImgSalt from "../images/food/salt.png";
import ImgMarmelade from "../images/food/mermelade.png";
import ImgCigar from "../images/cigar/cigar.png";
import ImgBracelet from "../images/jewellery/bracelet.png";
import ImgNecklace from "../images/jewellery/collar.png";
import ImgEarrings from "../images/jewellery/pendientes.png";
import { TranslationContext } from "../TranslationContext";

const ProductsHero = () => {
  const { translation } = React.useContext(TranslationContext);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Separate state variables for each category's carousel index
  const [souvenirsIndex, setSouvenirsIndex] = useState(0);
  const [foodIndex, setFoodIndex] = useState(0);
  const [jewelleryIndex, setJewelleryIndex] = useState(0);
  const [cigarIndex, setCigarIndex] = useState(0);

  const souvenirs = [ImgDecoration, ImgNoteook, ImgEstuche, ImgMug];
  const food = [ImgMojo, ImgOlive, ImgSalt, ImgMarmelade];
  const jewellery = [ImgBracelet, ImgNecklace, ImgEarrings];
  const cigars = [ImgCigar];

  useEffect(() => {
    const updateScreenSize = () => setIsSmallScreen(window.innerWidth <= 450);
    window.addEventListener("resize", updateScreenSize);
    updateScreenSize();
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  // Generic handler for previous and next buttons
  const handlePrev = (length, setIndex) => {
    setIndex((prevIndex) => (prevIndex === 0 ? length - 1 : prevIndex - 1));
  };

  const handleNext = (length, setIndex) => {
    setIndex((prevIndex) => (prevIndex === length - 1 ? 0 : prevIndex + 1));
  };

  const renderGallery = (images, currentIndex, setIndex) => {
    if (isSmallScreen) {
      return (
        <div className="carousel">
          {images.length > 1 && (
            <button
              className="carousel-button prev"
              onClick={() => handlePrev(images.length, setIndex)}
            >
              &#8249; {/* Left arrow */}
            </button>
          )}
          <img
            className="carousel-image"
            src={images[currentIndex]}
            alt="Gallery Item"
          />
          {images.length > 1 && (
            <button
              className="carousel-button next"
              onClick={() => handleNext(images.length, setIndex)}
            >
              &#8250; {/* Right arrow */}
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="gallery">
        {images.map((image, index) => (
          <img key={index} src={image} alt={`Gallery Item ${index}`} />
        ))}
      </div>
    );
  };

  return (
    <div className="products-hero-container">
      <div className="products-smaller-container">
        <h1 id="products-hero-h1">{translation.galleryH1}</h1>

        {/* Souvenirs Section */}
        <div className="souvenirs-hero-container">
          <h1>{translation.souvenir}</h1>
          {renderGallery(souvenirs, souvenirsIndex, setSouvenirsIndex)}
        </div>

        {/* Food Section */}
        <div className="food-hero-container">
          <h1>{translation.aliments}</h1>
          {renderGallery(food, foodIndex, setFoodIndex)}
        </div>

        {/* Jewellery Section */}
        <div className="jewellery-hero-container">
          <h1>{translation.jewellery}</h1>
          {renderGallery(jewellery, jewelleryIndex, setJewelleryIndex)}
        </div>

        {/* Cigars Section */}
        <div className="cigars-hero-container">
          <h1>{translation.cigar}</h1>
          {renderGallery(cigars, cigarIndex, setCigarIndex)}
        </div>

        {/* Animated Typed Section */}
        <div ref={ref}>
          {inView && (
            <h1 className="h1-mas">
              <ReactTyped
                strings={[translation.galleryMás]}
                typeSpeed={70}
                backSpeed={30}
                showCursor={false}
              />
            </h1>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsHero;
